import React from 'react';
import bubbles from "../../mascot/bubble_right.svg";

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export default class NotEnoughButtonsFeedback extends React.Component{
    constructor(props){
        super(props);
    }

    /*
    * Renders and returns the notEnoughButtonsFeedback component.
    */
    render(){
        return(
            <div>
                <img src={bubbles}  className="Feedback-Mascot" alt={"Bubbles, das Maskottchen des Bubblesort-Tutors, eine blaue und lilane Seifenblase."}/>    
                <p>
                    Schau nochmal genau hin! Bevor du entscheidest, ob du zwei Zahlen vertauschen oder nicht verstauschen möchtest,
                    wähle die beiden Zahlen aus, indem du auf sie klickst. Versuch es doch gleich mal!
                </p>
            </div>
        )};
    }